import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.scss';
import Cookies from 'js-cookie';
const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (lang: string) => {
    console.log(`Cambiando idioma a: ${lang}`);
    i18n.changeLanguage(lang); // Cambia el idioma
    Cookies.set('i18next', lang);

  };

  return (
    <div className="language-btn">
      
      <button onClick={() => handleLanguageChange('es')} >
  <img src="/assets/img/spainflag.png" alt="Spanish Flag" className="flag-icon" />
</button>
<button onClick={() => handleLanguageChange('en')} >
  <img src="/assets/img/ukflag.png" alt="English Flag" className="flag-icon" />
</button>

    </div>
  );
};

export default LanguageSelector;
